<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>APLICAÇÕES</span>
                </h4>
                <app-tabela
                    idTabela="tblAplicacoes"
                    :itens="aplicacoes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <btn-inserir-aplicacao></btn-inserir-aplicacao>
                    </template>
                    <template slot="fimVigencia" slot-scope="data">
                        {{
                            data.fimVigencia
                                ? $moment(data.fimVigencia).format('DD/MM/YYYY')
                                : 'NÃO ESPECIFICADO'
                        }}
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-detalhar-aplicacao
                            :aplicacao="data"
                        ></btn-detalhar-aplicacao>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import AplicacoesServicos from './AplicacoesServicos.js'
import BtnInserirAplicacao from './BtnInserirAplicacao'
import BtnDetalharAplicacao from './BtnDetalharAplicacao'

export default {
    components: {
        BtnInserirAplicacao,
        BtnDetalharAplicacao
    },

    data() {
        return {
            aplicacoes: [],
            campos: [
                {
                    key: 'codigo',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'fimVigencia',
                    label: 'Acesso até'
                },
                {
                    key: 'validadeToken',
                    label: 'Token válido até',
                    type: 'datetime'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterAplicacoes() {
            this.$store.dispatch('addRequest')
            AplicacoesServicos.obterTodas().then(response => {
                if (response) {
                    if (response.success) {
                        this.aplicacoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterAplicacoes()
    },

    computed: {
        mostrarTabela() {
            return this.$route.name === 'Aplicacoes'
        }
    },

    watch: {
        $route(to, from) {
            if (to.name === 'Aplicacoes') {
                if (this.$store.getters.recarregar) {
                    this.obterAplicacoes()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    }
}
</script>
